var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: {
          content: "Datos de Destrezas y otra información recopilada",
          "has-line": ""
        }
      }),
      !_vm.isReadOnly
        ? _c(
            "div",
            { staticClass: "my-3" },
            [
              _c(
                "div",
                { staticClass: "col-md-8 d-flex align-items-end" },
                [
                  _c("custom-drop-down", {
                    staticClass: "w-80",
                    attrs: {
                      clearable: "",
                      fieldkey: "id",
                      fieldname: "name",
                      label: "Añadir Destreza:",
                      options: _vm.availableSkills
                    },
                    model: {
                      value: _vm.skillSelected,
                      callback: function($$v) {
                        _vm.skillSelected = $$v
                      },
                      expression: "skillSelected"
                    }
                  }),
                  _c(
                    "action-button",
                    {
                      staticClass: "ml-2",
                      attrs: {
                        disabled: !_vm.skillSelected,
                        i: "fas fa-file-plus",
                        variant: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.addSkill()
                        }
                      }
                    },
                    [_vm._v(" Añadir ")]
                  )
                ],
                1
              ),
              _c("validation-provider", {
                ref: "skills",
                attrs: {
                  name: "skills",
                  rules: _vm.model.skills.length > 0 ? "" : "required"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          errors[0]
                            ? _c("error", {
                                staticClass: "m-3",
                                attrs: {
                                  message: "Añada al menos una destreza",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2781058078
                )
              })
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "row my-2" }, [
        _c(
          "div",
          { staticClass: "col-12 d-flex justify-content-lg-end" },
          [
            _c("action-button", {
              staticClass: "outline-dark-gray",
              attrs: {
                i: _vm.anyCollapseOpen
                  ? "fal fa-compress-alt"
                  : "fal fa-expand-alt",
                text: _vm.anyCollapseOpen ? "Colapsar Todo" : "Expandir Todo"
              },
              on: {
                click: function($event) {
                  return _vm.expandAll(!_vm.anyCollapseOpen)
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._l(_vm.model.skills, function(item) {
        return _c(
          "skill-collapse",
          {
            key: item.id,
            attrs: {
              description: item.description,
              disabled: _vm.isReadOnly,
              title: item.name,
              value: _vm.collapseState[item.id]
            },
            on: {
              input: function($event) {
                return _vm.updateCollapseState(item.id, $event)
              },
              remove: function($event) {
                return _vm.remove(item)
              }
            }
          },
          [
            _c("skill-content", {
              attrs: {
                answers: _vm.model.answers,
                "is-read-only": _vm.isReadOnly,
                value: item
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }